import base from './base';

export const date = (value: any) => {
	value = base(value);
	if (Array.isArray(value)) {
		value = value
			.map((value) => {
				return Number.isInteger(value)
					? value
					: value.replace(/(\d+)-(\d+)-(\d+)/, '$2/$3/$1');
			})
			.map((value) =>
				typeof value === 'string'
					? value
							.split('/')
							.map((piece) => piece.padStart(2, '0'))
							.join('/')
					: value,
			);
	} else if (typeof value === 'string') {
		value = value
			.replace(/(\d+)-(\d+)-(\d+)/, '$2/$3/$1')
			.split('/')
			.map((piece) => piece.padStart(2, '0'))
			.join('/');
	}
	return value;
};

export default date;
